import React from "react";
import { Banner } from "./banner";

export const BannerContainer = () => {
  const imageBanner = `${process.env.PUBLIC_URL}/images/banner/espirito_santo_banner.webp`;

  return <Banner imageBanner={imageBanner} />;
};   